const { REACT_APP_LOCAL_DB } = process.env

let CX_MAJOR: number = 0
let CX_FEATURE: number = 0
let CX_BUGFIXES: number = 0
let SITE_MAJOR: number = 0
let SITE_FEATURE: number = 0
let SITE_BUGFIXES: number = 0

switch (REACT_APP_LOCAL_DB) {
  case 'local':
    CX_MAJOR = 3
    CX_FEATURE = 6
    CX_BUGFIXES = 19
    SITE_MAJOR = 1
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  case 'report':
  case 'server':
  case 'dev':
    CX_MAJOR = 3
    CX_FEATURE = 7
    CX_BUGFIXES = 56
    SITE_MAJOR = 1
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  // case 'staging':
  case 'staging-einvoice':
  case 'demo':
    CX_MAJOR = 3
    CX_FEATURE = 4
    CX_BUGFIXES = 52
    SITE_MAJOR = 1
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  // NEWLY ADDED ENHANCEMENT TO UAT ENV
  case 'azure-einvoice':
  case 'uat':
    CX_MAJOR = 3
    CX_FEATURE = 5
    CX_BUGFIXES = 42
    SITE_MAJOR = 1
    SITE_FEATURE = 1
    SITE_BUGFIXES = 0
    break
  // UAT-MC
  case 'uat-mc':
    CX_MAJOR = 5
    CX_FEATURE = 0
    CX_BUGFIXES = 17
    SITE_MAJOR = 1
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  //Staging
  case 'staging':
    CX_MAJOR = 3
    CX_FEATURE = 5
    CX_BUGFIXES = 21
    SITE_MAJOR = 1
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  case 'prod2':
    CX_MAJOR = 5
    CX_FEATURE = 0
    CX_BUGFIXES = 10
    SITE_MAJOR = 2
    SITE_FEATURE = 0
    SITE_BUGFIXES = 0
    break
  // CONTROLLED LIVE VERSION
  default:
    CX_MAJOR = 4
    CX_FEATURE = 5
    CX_BUGFIXES = 64
    SITE_MAJOR = 1
    SITE_FEATURE = 1
    SITE_BUGFIXES = 0
    break
}

export const CX_VERSION = `V${CX_MAJOR}.${CX_FEATURE}.${CX_BUGFIXES}`
export const SITE_VERSION = `V${SITE_MAJOR}.${SITE_FEATURE}.${SITE_BUGFIXES}`
